
import React from 'react';

import { TabPanel } from '../../core';
import PrintPanel from './PrintPanel';

const renderTabPanel = (props) => {
    return (
        <TabPanel key={props.name} name={props.name} iconName={props.iconName} title={props.title}>
            <PrintPanel />
        </TabPanel>
    );
}

export default renderTabPanel;
